/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {FunctionComponent} from 'react';
import {ImpactType} from '@ion/core/src/types/entities';
import {IconProps} from '../types/types';
import {BottomImpactIcon} from './BottomImpactIcon';
import {NoImpactIcon} from './NoImpactIcon';
import {TopImpactIcon} from './TopImpactIcon';

export interface ImpactTypeIconProps {
  impactType: string;
}

/**
 * Provides a map for the impact type prop and the respective icon.
 */
const impactTypeIconMap = {
  [ImpactType.Drop]   : BottomImpactIcon,
  [ImpactType.Impact] : TopImpactIcon
};

/**
 * The ImpactTypeIcon is a component that dynamically renders the appropriate
 * icon based on the impact type.
 *
 * ```typescript
 *
 *    import {ImpactTypeIcon} from '@ion/dls/src/icons/ImpactTypeIcon';
 *
 *     <ImpactTypeIcon impactType={'top'} /> // renders the top impact icon
 *     <ImpactTypeIcon impactType={'bottom'} /> // renders the bottom impact icon
 *     <ImpactTypeIcon impactType={''} /> // renders the no impact icon
 *
 * ```
 */
export const ImpactTypeIcon = ({impactType}: ImpactTypeIconProps) => {
  if (impactType) {
    const ImpactIcon: FunctionComponent<IconProps> = impactTypeIconMap[impactType] || NoImpactIcon;
    return <ImpactIcon />;
  }
};
